export default "__VITE_ASSET__BGrn43Rr__"